var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-breadcrumb"},[_c('Breadcrumb',_vm._l((_vm.BreadMenuData),function(item,index){return _c('BreadcrumbItem',{key:`item-${index}`},[_vm._v("\n      "+_vm._s(_vm.menuListTitle[item.name] ? _vm.menuListTitle[item.name] : item.name)+"\n    ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }